export default {"src":"/_next/static/media/delete-icon.15aa73ac.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};